const scrollBtn = document.querySelector('.js-scroll-up-button');
const VISIBLE_CLASS = 'is-visible';
let timer = 0;

document.addEventListener('scroll', () => {
	clearTimeout(timer);
	timer = setTimeout(
		() => scrollBtn.classList.toggle(VISIBLE_CLASS, window.scrollY > 500),
		100,
	);
});

scrollBtn.addEventListener('click', (e) => {
	e.preventDefault();
	window.scrollTo({
		top: 0,
		behavior: 'smooth',
	});
});
